import { Component, computed } from '@angular/core';
import { CellAdapter } from '../cell.adapter';
import { ImageColumnDefinition } from '../../../types/colum-definition.type';

@Component({
  selector: 'app-image-cell',
  template: `
    @if (imageUrl()) {
    <img
      [src]="imageUrl()"
      [alt]="column().name"
      [style.height]="height()"
      [style.width]="width()"
      [style.object-fit]="objectFit()"
      class="mx-auto" />
    } @else {
    <span class="text-gray-400 text-sm">{{ fallbackText() }}</span>
    }
  `,
  standalone: true,
})
export class ImageCell extends CellAdapter {
  imageColumn = computed(
    () => this.column() as unknown as ImageColumnDefinition
  );

  imageUrl = computed(() => {
    const field = this.column().field;
    return this.row()?.[field] || null;
  });

  height = computed(() => this.imageColumn().imageHeight || '40px');
  width = computed(() => this.imageColumn().imageWidth || 'auto');
  objectFit = computed(() => this.imageColumn().objectFit || 'contain');
  fallbackText = computed(
    () => this.imageColumn().fallbackText || '이미지 없음'
  );
}
